
import { Component, Vue } from 'vue-property-decorator';
import VideoPlayerMinimal from '~/components/UIComponents/VideoPlayerMinimal.vue';

@Component({
  components: {
    VideoPlayerMinimal,
  },
})
export default class PopcornExplainer extends Vue {
  videoSrc = `https://static.gala.games/gala-film/videos/gala_film_popcorn.mp4`;

  get heading() {
    return this.$t('components.nodes.popcornExplainer.rewards') as string;
  }

  get body() {
    return [
      this.$t('components.nodes.popcornExplainer.ifYou') as string,
      this.$t('components.nodes.popcornExplainer.onceOurEcosystem') as string,
      this.$t('components.nodes.popcornExplainer.untilThen') as string,
    ];
  }

  get items() {
    return [
      this.$t('components.nodes.popcornExplainer.whyPopcorn') as string,
      this.$t('components.nodes.popcornExplainer.earnPopcorn') as string,
      this.$t('components.nodes.popcornExplainer.collectPopcorn') as string,
      this.$t('components.nodes.popcornExplainer.morePopcorn') as string,
    ];
  }
}
